import { SortDirection } from '../list-conductor/sort';

export const SORT_LABELS = {
  [SortDirection.RESET]: 'Sort Ascending',
  [SortDirection.ASC]: 'Sort Descending',
  [SortDirection.DESC]: 'Reset Sort'
};
